import { UserContactUs } from './Auth';
import { OSVersion } from './OSVersion';
import { TblBidDataDisplay } from './TblBidDataDisplay';

export class CrashMailInputParameters {
  BidData: TblBidDataDisplay;

  UserData: UserContactUs;

  OS: OSVersion;

  ErrorContent: string;

  DateTime: Date;

  OnlineStatus: boolean;
}
